<template>
  <nav id="ml-menu" class="menu">

    <nav class="menu__breadcrumbs" aria-label="You are here">
      <a
        @click="handleBreadCrubClick(breadcrumb)"
        v-for="(breadcrumb, i) in breadcrumbs"
        v-bind:key="i"
        href="#"
        >{{ breadcrumb.title }}</a
      >
    </nav>

    <!-- <button
      class="menu__back"
      v-bind:class="{ 'menu__back--hidden': breadcrumbs.length <= 1 }"
      aria-label="Go back"
    >
       <span class="fas fa-chevron-right"></span>
      برگشت
    </button> -->

    <div class="menu__wrap">
      <ul
        ref="menu"
        class="menu__level"
        tabindex="-1"
        role="menu"
        aria-label="All"
      >
        <li
          v-for="(currentItem, i) in currentItems"
          v-bind:key="i"
          class="menu__item"
          role="menuitem"
        >
          <a
            @click.prevent="handleClick(currentItem, i)"
            class="menu__link"
            v-bind:class="{
              'has-sub':
                currentItem.children && currentItem.children.length > 0,
                
            }"
            aria-owns="submenu-1"
            href="#"
            >{{ currentItem.title }}</a
          >
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

export default {
  components: {},

  props: {
    items: {
      Type: Array,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      currentItems: [],
      breadcrumbs: [],
    };
  },
  computed: {},
  mounted() {
    this.breadcrumbs.push({
      title: "همه",
      index: -1,
    });
    this.currentItems = this.items;
    this.$refs.menu.classList.add("menu__level--current");
  },
  created() {},
  methods: {
    handleClick(item, index) {
      this.$refs.menu.classList.remove("menu__level--current");
      if (item.children && item.children.length > 0) {
        this.currentItems = item.children;
        this.breadcrumbs.push({
          title: item.title,
          index: index,
        });
      }

      this.$refs.menu.classList.add("menu__level--current");
      // this.$el
      //   .querySelector(".menu__level--current")
      //   .classList.remove("menu__level--current");
      // var subMenu = event.target.getAttribute("data-submenu");
      // this.$refs[subMenu].classList.add("menu__level--current");

      this.$emit('select', item)

    },

    handleBreadCrubClick(item) {
      // console.log(item, index);
      let newB = [];
      let curItem;
      this.breadcrumbs.some((breadcrumb, i) => {
        newB.push(breadcrumb);
        if (breadcrumb.index == -1) {
          curItem = this.items;
        } else {
          curItem = curItem[breadcrumb.index].children;
        }

        if (item.index == breadcrumb.index) {
          this.breadcrumbs = newB;
          this.currentItems = curItem;

           this.$emit('select', curItem)

          return true;
        }
      });
    },

    closeMenu() {},
  },

  watch: { 
      	items: function(newVal, oldVal) { // watch it

        this.currentItems = newVal;
          // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
      }
};
</script>

<style lang="scss">
/* Menu styles */

.menu {
  position: relative;
  width: 100%;
  
}

.menu__wrap {
  overflow: hidden;
  width: 100%;
}

.menu__level {
  position: relative;
  top: 0;
  right: 0;
  visibility: hidden;
  overflow: hidden;
  overflow-y: hidden;
  width: calc(100%);
  height: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  transform: translateX(-100%);
  transition: 1s transform ease-in;
}

.menu__level:focus {
  outline: none;
}

.menu__level--current {
  visibility: visible;
  transform: translateX(0);
}

.menu__item {
  display: block;
  width: calc(100%);
}

.menu__link {
  font-weight: 600;
  position: relative;
  display: block;
  padding: .7rem 1rem;
  -webkit-transition: color 0.1s;
  transition: color 0.1s;
}

.menu__link.has-sub::after {
  content: "\f0d9";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  left: 0;
  padding: 0 1em;
  color: #2a2b30;
}

.menu__link:hover,
.menu__link:focus,
.menu__link.has-sub:hover::after,
.menu__link.has-sub:focus::after {
}

.menu__link--current::before {
  content: "\00B7";
  font-size: 1.5em;
  line-height: 0;
  position: absolute;
  top: 50%;
  left: 0.5em;
  height: 4px;
}

[class^="animate-"],
[class*=" animate-"] {
  visibility: visible;
}

.animate-outToRight .menu__item {
  -webkit-animation: outToRight 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
  animation: outToRight 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
}

@-webkit-keyframes outToRight {
  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes outToRight {
  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.animate-outToLeft .menu__item {
  -webkit-animation: outToLeft 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
  animation: outToLeft 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
}

@-webkit-keyframes outToLeft {
  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes outToLeft {
  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.animate-inFromLeft .menu__item {
  -webkit-animation: inFromLeft 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
  animation: inFromLeft 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
}

@-webkit-keyframes inFromLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes inFromLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate-inFromRight .menu__item {
  -webkit-animation: inFromRight 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
  animation: inFromRight 0.6s both cubic-bezier(0.7, 0, 0.3, 1);
}

@-webkit-keyframes inFromRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes inFromRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.menu__breadcrumbs {
  font-size: 0.8rem;
  position: relative;
  padding: .7rem 1rem;
}

.menu__breadcrumbs a {
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  text-transform: uppercase;
}

.menu__breadcrumbs a:last-child {
  pointer-events: none;
  color: #7f7f7f;
}

.menu__breadcrumbs a:hover,
.menu__breadcrumbs a:focus {
}

.menu__breadcrumbs a:not(:last-child)::after {
  content: "\f053";
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  padding: 0 0.5em;
  color: #33353e;
}

.menu__breadcrumbs a:not(:last-child):hover::after,
.menu__breadcrumbs a:not(:last-child):focus::after {
  color: #33353e;
}

.menu__back {
  font-size: .8rem;
  margin-right:.5rem;
 
  cursor: pointer;
  color: #2a2b30;
  border: none;
  background: none;
}

.menu__back--hidden {
  pointer-events: none;
  display: none;
  opacity: 0;
}

.menu__back:hover,
.menu__back:focus {
  color: #cb1027;
  outline: none;
}

/* Open and close buttons */

.action {
  position: absolute;
  display: block;
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: none;
  background: none;
}

.action:focus {
  outline: none;
}

.action--open {
  font-size: 1.5em;
  top: 1em;
  left: 1em;
  display: none;
  color: #fff;
  position: fixed;
  z-index: 1000;
}

.action--close {
  font-size: 1.1em;
  top: 1.25em;
  right: 1em;
  display: none;
  color: #45464e;
}

@media screen and (max-width: 40em) {
  .action--open,
  .action--close {
    display: block;
  }
  .menu {
    z-index: 1000;
    top: 0;
    width: 100%;
    height: 100vh;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    -webkit-transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
  }
  .menu--open {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
</style>
